/**
 * Vuex module for real-time WebSocket state.
 * Manages Socket.io connection status and incoming real-time data
 * (car counts, alerts, controller status, user activity).
 */

const MAX_ACTIVITY_ITEMS = 20

const state = {
  connected: false,
  lastCarCount: null,
  liveAlerts: [],
  controllerStatus: null,
  recentActivity: []
}

const getters = {
  isSocketConnected: state => state.connected,
  getLastCarCount: state => state.lastCarCount,
  getLiveAlerts: state => state.liveAlerts,
  getLiveControllerStatus: state => state.controllerStatus,
  getRecentActivity: state => state.recentActivity
}

const mutations = {
  setSocketConnected(state, connected) {
    state.connected = connected
  },

  setLastCarCount(state, data) {
    state.lastCarCount = data
  },

  addLiveAlert(state, alert) {
    // Add to the front of the array (most recent first)
    state.liveAlerts.unshift({
      ...alert,
      receivedAt: new Date().toISOString()
    })
  },

  closeLiveAlert(state, data) {
    // Remove from live alerts if present
    state.liveAlerts = state.liveAlerts.filter(a => a.id !== data.id)
  },

  clearLiveAlerts(state) {
    state.liveAlerts = []
  },

  setLiveControllerStatus(state, data) {
    state.controllerStatus = data
  },

  clearLiveControllerStatus(state) {
    state.controllerStatus = null
  },

  pushActivity(state, activity) {
    state.recentActivity.unshift({
      ...activity,
      receivedAt: new Date().toISOString()
    })
    // Keep only the most recent items
    if (state.recentActivity.length > MAX_ACTIVITY_ITEMS) {
      state.recentActivity = state.recentActivity.slice(0, MAX_ACTIVITY_ITEMS)
    }
  },

  clearRecentActivity(state) {
    state.recentActivity = []
  },

  // Reset all socket state (e.g. on site change or logout)
  resetSocketState(state) {
    state.lastCarCount = null
    state.liveAlerts = []
    state.controllerStatus = null
    state.recentActivity = []
  }
}

export default { state, getters, mutations }
